<section class="section section-gradient-2 integrations-section">
  <div class="container text-center">
    <h2 class="section-title">Seamless Integrations</h2>
    <p class="section-subtitle">KOTHA is fully compatible with the industry-leading hardware and CRM software your team already uses.</p>
    
    <div class="integrations-wrapper">
      <div class="integration-group">
        <h4 class="integration-label">Supported Hardware</h4>
        <div class="brand-tags">
          <span *ngFor="let brand of hardwareBrands" class="brand-tag">{{brand}}</span>
        </div>
      </div>
      
      <div class="integration-group">
        <h4 class="integration-label">Software Integrations</h4>
        <div class="brand-tags">
          <span *ngFor="let brand of softwareBrands" class="brand-tag software-tag">{{brand}}</span>
        </div>
      </div>
    </div>
  </div>
</section>
